import React, { Component } from 'react';
import './App.css';
import Header from './Components/Header'
import OrderModal from './Components/OrderModal'
import PayinModal from "./Components/PayinModal"
import SideMenu from './Components/SideMenu'
import CabinetPage from './Pages/CabinetPage'
import SettingsPage from './Pages/SettingsPage'
import RentPage from './Pages/RentPage'
import TeleMailerPage from './Pages/TeleMailerPage'
import LoginPage from './Pages/LoginPage'
import DevPage from './Pages/DevPage'
import BoostPage from './Pages/BoostPage'
import PartnersPage from './Pages/PartnersPage'
import AdminPage from './Pages/AdminPage'
import TeleSearchPage from  './Pages/TeleSearchPage'
import TeleViewsPage from './Pages/TeleViews'
import APIPage from './Pages/APIPage'

import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  Redirect,
  withRouter
} from 'react-router-dom'
import axios from 'axios'

const fakeAuth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 100) // fake async
  },
  signout(cb) {
    this.isAuthenticated = false
    setTimeout(cb, 100) // fake async
  }
}

class Login extends React.Component {
  state = {
    redirectToReferrer: false
  }

  login = () => {
    fakeAuth.authenticate(() => {
      this.setState(() => ({
        redirectToReferrer: true
      }))
    })
  }


  componentWillMount() {
    axios.get("https://nakrutkatop.com:443/api/auth/isAuth", { withCredentials: true }).then(res => {
      setTimeout(() => {
        try {
          document.getElementsByClassName("loginPage")[0].style.opacity = 1
          document.getElementsByClassName("loginPage")[0].style.visibility = "visible"
        }
        catch { }
      }, 133)
      if (res.data.status == "Authorized") this.login()
    })

    setTimeout(() => {
      try {
        document.getElementsByClassName("loginPage")[0].style.opacity = 1
        document.getElementsByClassName("loginPage")[0].style.visibility = "visible"
      }
      catch { }
    }, 1500)
  }

  render() {

    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer } = this.state

    if (redirectToReferrer === true) {
      return <Redirect to={from} />
    }

    return (
      <LoginPage loginF={this.login} />
    )
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  console.log(rest)
  return <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} updateBalance={rest.updateBalance}/>
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
}

const AuthButton = withRouter(({ history }) => (
  fakeAuth.isAuthenticated
    ? <p>
      Welcome! <button onClick={() => {
        fakeAuth.signout(() => history.push('/'))
      }}>Sign out</button>
    </p>
    : <p>You are not logged in.</p>
))

class App extends Component {
  constructor(props) {
    super(props);
    this.updateBalance = this.updateBalance.bind(this)
    this.state = {
      balance: 0,
    }
  }
  
  updateBalance = () => {
    axios.get("https://nakrutkatop.com:443/api/cabinet", { withCredentials: true })
    .then(res => {if(res.data.balance) this.setState({balance: Math.floor(res.data.balance)})})
  }

  componentDidMount() {
    axios.get("https://nakrutkatop.com:443/api/auth/isAuth", { withCredentials: true, credentials: 'same-origin', crossdomain: true })
      .then(res => {
        console.log(res.data)
        if (res.data.status == "Authorized") console.log(1)
      }
      )
  }

  render() {
    return (
      <body data-spy="scroll" data-target=".fixed-top" className="App">

        <OrderModal />
        <PayinModal />
        <Header updateBalance={this.updateBalance} balance={this.state.balance}/>
        <SideMenu />

        <Switch>
          <Route exact path='/' component={CabinetPage} />
          <PrivateRoute exact path='/cabinet' component={CabinetPage} />
          <PrivateRoute exact path='/settings' component={SettingsPage} />
          <PrivateRoute exact path='/admin' component={AdminPage} />

          <PrivateRoute path='/partners' component={PartnersPage} />

          <Route path='/boost' component={BoostPage} />
          <Route path='/api-reference' component={APIPage} />
          <PrivateRoute path='/telemailer' component={TeleMailerPage} updateBalance={this.updateBalance}/>
          <PrivateRoute path='/telesearch' component={TeleSearchPage} updateBalance={this.updateBalance}/>
          <PrivateRoute path='/televiews' component={TeleViewsPage} updateBalance={this.updateBalance}/>
          
          <PrivateRoute path='/parsing' component={DevPage} />
          <PrivateRoute path='/rent' component={RentPage} />
          <PrivateRoute path='/proxy' component={DevPage} />
          <Route path='/forum' component={DevPage} />
          <Route path='/articles' component={DevPage} />

          <Route path='/login' component={Login} />
        </Switch>



      </body>
    )
  }
}

export default App;
